import type { IRect } from '@nova/types';

import { countRectTilesWithValue, writeRectValue } from './tile-grid';

/** Inputs for clearing filled cells inside one or more axis-aligned rects. */
export interface ClearFilledTilesInRectsArgs {
  grid: Uint8Array;
  width: number;
  height: number;
  rects: readonly IRect[];
  filledValue: number;
  clearValue?: number;
}

/**
 * Clears every cell in each rect to `clearValue`.
 * Returns how many cells previously held `filledValue`.
 */
export function clearFilledTilesInRects(args: ClearFilledTilesInRectsArgs): number {
  const clearValue = args.clearValue ?? 0;
  let clearedFilled = 0;

  for (const rect of args.rects) {
    clearedFilled += countRectTilesWithValue(args.grid, args.width, args.height, rect, args.filledValue);
    writeRectValue(args.grid, args.width, args.height, rect, clearValue);
  }

  return clearedFilled;
}
